/* PRJ-31 mx-form engine — schema-driven Typeform replacement (Maia, 2026-07-02)
 * Renders one form per JSON config (window.MX_FORM_CONFIGS), one question at a time.
 * No dependencies. Submits multipart/form-data to a Make.com webhook (simple CORS request).
 * Field types: shorttext, longtext, email, url, tel, number, select (single/multiple),
 *              rating, image-select, file, group (multi-input single screen).
 */
(function () {
  'use strict';

  var root = document.getElementById('mx-form');
  if (!root) return;

  var CONFIGS = window.MX_FORM_CONFIGS || {};
  var cfg = CONFIGS[root.dataset.formId];
  if (!cfg) { root.innerHTML = '<p class="mxf-error">Form not found.</p>'; return; }

  var ENDPOINT = root.dataset.endpoint || '';
  var TOKEN = root.dataset.token || '';
  var STORE = root.dataset.store || '';

  var answers = {};   // key -> value (string | array | File)
  var current = 0;    // index into visibleFields()
  var startedAt = Date.now(); // min-time bot guard

  // URL context (e.g. ?order=1234 on a post-purchase link). Capture only -- never
  // prefills or alters an answer, so a crafted link cannot put words in a mouth.
  // Context values are arbitrary text from whoever wrote the link, and they land in a
  // spreadsheet. A cell beginning = + - @ is evaluated as a FORMULA by Sheets and Excel, so
  // ?ref==HYPERLINK("http://evil","Click") would become a live link in a sheet people read.
  // Leading apostrophe is the standard neutraliser: the value is preserved, read as text.
  function deFormula(s) {
    return /^[=+\-@\t\r]/.test(s) ? "'" + s : s;
  }

  var context = (function () {
    var out = {}, n = 0;
    try {
      new URLSearchParams(location.search).forEach(function (v, k) {
        if (n >= 20) return;
        k = String(k).slice(0, 40).replace(/[^\w.-]/g, '');
        if (!k || v === '') return;
        out[k] = deFormula(String(v).slice(0, 200));
        n++;
      });
    } catch (e) { /* malformed query or old browser -- context is optional, never fatal */ }
    return out;
  })();

  /* ---------- Cloudflare Turnstile (optional; on when a site key is set on the section) ----------
   * Invisible challenge. On submit we execute() it, get a single-use token, and post it so the
   * Make scenario can verify it server-side (siteverify) — this is what stops direct webhook spam
   * that skips the form JS. Blank site key = disabled, form behaves exactly as before. */
  var TS_SITEKEY = root.dataset.turnstileSitekey || '';
  var tsToken = '';           // solved token, consumed per send, auto-refreshed on expiry
  var tsWidgetId = null;
  var tsPendingSend = false;
  var tsTries = 0;
  function initTurnstile() {
    if (!TS_SITEKEY) return;
    if (!window.turnstile) { if (++tsTries < 40) setTimeout(initTurnstile, 150); return; } // api.js loading
    var box = document.createElement('div');
    box.id = 'mxf-turnstile';
    box.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;';
    document.body.appendChild(box);
    try {
      tsWidgetId = window.turnstile.render('#mxf-turnstile', {
        sitekey: TS_SITEKEY,
        size: 'invisible',
        'refresh-expired': 'auto',
        callback: function (t) { tsToken = t; if (tsPendingSend) { tsPendingSend = false; doSend(); } },
        'error-callback': function () { tsToken = ''; if (tsPendingSend) { tsPendingSend = false; doSend(); } }
      });
    } catch (e) { /* misconfigured key — let Make's server-side check be the gate */ }
  }
  initTurnstile();

  /* ---------- branching: tiny showIf evaluator ("key <= 3", "key != 'No'") ---------- */
  function passes(field) {
    // Context may SUPPRESS a question whose answer the link already carried, but it never
    // answers one. Suppressing cannot put words in a respondent's mouth; prefilling could.
    if (field.skipIfContext && context[field.skipIfContext]) return false;
    if (!field.showIf) return true;

    // "key contains 'Value'" -- multi-select answers are arrays, so == cannot match one entry
    var c = field.showIf.match(/^[ 	]*([A-Za-z0-9_]+)[ 	]+contains[ 	]+(.+?)[ 	]*$/);
    if (c) {
      var cv = answers[c[1]];
      var want = /^'.*'$|^".*"$/.test(c[2]) ? c[2].slice(1, -1) : c[2];
      if (cv === undefined || cv === null || cv === '') return false;
      return Array.isArray(cv) ? cv.indexOf(want) > -1 : String(cv).indexOf(want) > -1;
    }

    var m = field.showIf.match(/^\s*(\w+)\s*(<=|>=|!=|==|=|<|>)\s*(.+?)\s*$/);
    if (!m) return true;
    var left = answers[m[1]], op = m[2], raw = m[3];
    var right = /^'.*'$|^".*"$/.test(raw) ? raw.slice(1, -1) : parseFloat(raw);
    if (left === undefined || left === null || left === '') return false;
    if (typeof right === 'number') left = parseFloat(left);
    switch (op) {
      case '<=': return left <= right;
      case '>=': return left >= right;
      case '<':  return left <  right;
      case '>':  return left >  right;
      case '!=': return String(left) !== String(right);
      default:   return String(left) === String(right);
    }
  }
  function visibleFields() { return cfg.fields.filter(passes); }

  /* ---------- rendering ---------- */
  function h(tag, cls, html) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (html !== undefined) el.innerHTML = html;
    return el;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render() {
    var fields = visibleFields();
    if (current >= fields.length) return submit();
    var f = fields[current];

    root.innerHTML = '';
    var wrap = h('div', 'mxf-wrap');

    // progress
    var pct = Math.round((current / fields.length) * 100);
    var prog = h('div', 'mxf-progress');
    prog.appendChild(h('div', 'mxf-progress-bar')).style.width = pct + '%';
    wrap.appendChild(prog);

    var card = h('div', 'mxf-card');
    card.appendChild(h('div', 'mxf-qnum', (current + 1) + ' / ' + fields.length));
    card.appendChild(h('h2', 'mxf-label', esc(f.label) + (f.required ? ' <span class="mxf-req">*</span>' : '')));
    if (f.help) card.appendChild(h('p', 'mxf-help', esc(f.help)));

    var body = h('div', 'mxf-body');
    card.appendChild(body);
    renderField(f, body);

    var err = h('p', 'mxf-error'); err.style.display = 'none';
    card.appendChild(err);

    // nav
    var nav = h('div', 'mxf-nav');
    if (current > 0) {
      var back = h('button', 'mxf-btn mxf-btn-back', 'Back');
      back.type = 'button';
      back.onclick = function () { current--; render(); };
      nav.appendChild(back);
    }
    var next = h('button', 'mxf-btn mxf-btn-next', current === fields.length - 1 ? esc(cfg.submitLabel || 'Submit') : 'Next');
    next.type = 'button';
    next.onclick = function () { advance(f, err); };
    nav.appendChild(next);
    card.appendChild(nav);

    wrap.appendChild(card);

    // honeypot (hidden from humans)
    var hp = h('input', 'mxf-hp');
    hp.type = 'text'; hp.name = 'mx_hp'; hp.tabIndex = -1;
    // 'new-password' + a name Chrome cannot classify: an address-profile autofill was
    // filling this and silently dropping every real submission.
    hp.setAttribute('autocomplete', 'new-password');
    hp.setAttribute('aria-hidden', 'true');
    hp.oninput = function () { answers.__hp = hp.value; };
    wrap.appendChild(hp);

    root.appendChild(wrap);

    // Enter advances (not in textareas)
    var first = body.querySelector('input, textarea, select, button');
    if (first) first.focus();
    body.onkeydown = function (e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') { e.preventDefault(); advance(f, err); }
    };
  }

  function renderField(f, body) {
    var t = f.type;

    if (t === 'rating') {
      var scale = f.scale || 5;
      var row = h('div', 'mxf-rating');
      row.setAttribute('role', 'radiogroup'); row.setAttribute('aria-label', f.label);
      for (var i = 1; i <= scale; i++) (function (n) {
        var b = h('button', 'mxf-star' + (answers[f.key] >= n ? ' is-on' : ''), '★');
        b.type = 'button'; b.setAttribute('aria-label', n + ' of ' + scale);
        b.onclick = function () { answers[f.key] = n; renderField(f, clear(body)); };
        row.appendChild(b);
      })(i);
      body.appendChild(row);

    } else if (t === 'select') {
      var multi = !!f.multiple;
      if (multi && !Array.isArray(answers[f.key])) answers[f.key] = answers[f.key] ? [answers[f.key]] : [];
      var list = h('div', 'mxf-options');
      (f.options || []).forEach(function (opt) {
        var label = typeof opt === 'string' ? opt : opt.label;
        var value = typeof opt === 'string' ? opt : (opt.value || opt.label);
        var on = multi ? answers[f.key].indexOf(value) > -1 : answers[f.key] === value;
        var b = h('button', 'mxf-opt' + (on ? ' is-on' : ''), esc(label));
        b.type = 'button'; b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.onclick = function () {
          if (multi) {
            var idx = answers[f.key].indexOf(value);
            idx > -1 ? answers[f.key].splice(idx, 1) : answers[f.key].push(value);
            renderField(f, clear(body));
          } else {
            answers[f.key] = value;
            renderField(f, clear(body));
          }
        };
        list.appendChild(b);
      });
      body.appendChild(list);
      if (multi) body.appendChild(h('p', 'mxf-help', 'Select all that apply.'));

    } else if (t === 'image-select') {
      var grid = h('div', 'mxf-imggrid');
      grid.style.setProperty('--mxf-cols', f.columns || 3);
      (f.options || []).forEach(function (opt) {
        var on = answers[f.key] === opt.value;
        var tile = h('button', 'mxf-tile' + (on ? ' is-on' : ''));
        tile.type = 'button'; tile.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (opt.image) {
          var img = h('img'); img.src = opt.image; img.alt = opt.label; img.loading = 'lazy';
          tile.appendChild(img);
        } else {
          tile.appendChild(h('span', 'mxf-tile-swatch'));
        }
        tile.appendChild(h('span', 'mxf-tile-label', esc(opt.label)));
        tile.onclick = function () { answers[f.key] = opt.value; renderField(f, clear(body)); };
        grid.appendChild(tile);
      });
      body.appendChild(grid);

    } else if (t === 'longtext') {
      var ta = h('textarea', 'mxf-input');
      ta.rows = 4; ta.value = answers[f.key] || '';
      ta.oninput = function () { answers[f.key] = ta.value; };
      body.appendChild(ta);

    } else if (t === 'file') {
      var fi = h('input', 'mxf-file');
      fi.type = 'file'; if (f.accept) fi.accept = f.accept;
      fi.onchange = function () { answers[f.key] = fi.files[0] || null; };
      body.appendChild(fi);
      if (answers[f.key] && answers[f.key].name) body.appendChild(h('p', 'mxf-help', 'Selected: ' + esc(answers[f.key].name)));

    } else if (t === 'group') {
      (f.inputs || []).forEach(function (sub) {
        var lab = h('label', 'mxf-sublabel', esc(sub.label) + (sub.required ? ' *' : ''));
        var inp = h('input', 'mxf-input');
        inp.type = sub.type === 'email' ? 'email' : sub.type === 'tel' ? 'tel' : 'text';
        inp.value = answers[sub.key] || '';
        inp.oninput = function () { answers[sub.key] = inp.value; };
        lab.appendChild(inp);
        body.appendChild(lab);
      });

    } else { // shorttext, email, url, tel, number
      var inp2 = h('input', 'mxf-input');
      inp2.type = t === 'email' ? 'email' : t === 'number' ? 'number' : t === 'url' ? 'url' : t === 'tel' ? 'tel' : 'text';
      inp2.value = answers[f.key] || '';
      inp2.oninput = function () { answers[f.key] = inp2.value; };
      body.appendChild(inp2);
    }
  }
  function clear(el) { el.innerHTML = ''; return el; }

  /* ---------- validation + advance ---------- */
  function validate(f) {
    var v = answers[f.key];
    if (f.type === 'group') {
      var bad = (f.inputs || []).filter(function (s) { return s.required && !String(answers[s.key] || '').trim(); });
      if (bad.length) return 'Please fill in: ' + bad.map(function (s) { return s.label; }).join(', ');
      var em = (f.inputs || []).filter(function (s) { return s.type === 'email' && answers[s.key]; });
      for (var i = 0; i < em.length; i++) if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(answers[em[i].key])) return 'Please enter a valid email for ' + em[i].label + '.';
      return null;
    }
    var empty = v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length);
    if (f.required && empty) return 'This question is required.';
    if (empty) return null;
    if (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'Please enter a valid email address.';
    if (f.type === 'url' && !/^(https?:\/\/)?[\w-]+(\.[\w-]+)+/.test(v)) return 'Please enter a valid link.';
    if (f.type === 'file' && f.accept && v && v.name) {
      var ok = f.accept.split(',').some(function (ext) { return v.name.toLowerCase().indexOf(ext.trim().toLowerCase()) > -1; });
      if (!ok) return 'Please upload one of: ' + f.accept;
    }
    return null;
  }

  function advance(f, errEl) {
    var msg = validate(f);
    if (msg) { errEl.textContent = msg; errEl.style.display = 'block'; return; }
    current++;
    render();
  }

  /* ---------- submit ---------- */
  function submit() {
    root.innerHTML = '<div class="mxf-wrap"><div class="mxf-card"><p class="mxf-help">Sending…</p></div></div>';

    // No backend wired yet: show a neutral notice instead of faking success (would lose answers).
    // Auto-clears the moment a webhook URL is set on the section in the theme editor.
    if (!ENDPOINT) {
      root.innerHTML = '';
      var pend = h('div', 'mxf-card');
      pend.appendChild(h('p', 'mxf-help', "This form isn't accepting responses just yet. Please check back soon."));
      root.appendChild(h('div', 'mxf-wrap')).appendChild(pend);
      return;
    }

    // bot guards: honeypot filled, or finished suspiciously fast
    if (answers.__hp || Date.now() - startedAt < 3000) return thanks(); // silently drop

    // Cloudflare Turnstile: fetch a fresh single-use token before sending (invisible challenge).
    if (TS_SITEKEY && !tsToken) {
      if (window.turnstile && tsWidgetId !== null) {
        tsPendingSend = true;
        try { window.turnstile.execute(tsWidgetId); return; } catch (e) { tsPendingSend = false; }
      }
      // widget failed to load — fall through; Make's siteverify will reject if a token is required
    }
    doSend();
  }

  function doSend() {
    var fd = new FormData();
    fd.append('form_id', cfg.id);
    fd.append('store', STORE);
    fd.append('mx_token', TOKEN);
    fd.append('submitted_at_iso', new Date().toISOString());
    // ctx_ prefix keeps URL context from colliding with an answer key in the flat copy
    var ctxKeys = Object.keys(context);
    if (ctxKeys.length) {
      fd.append('context_json', JSON.stringify(context));
      ctxKeys.forEach(function (k) { fd.append('ctx_' + k, context[k]); });
    }
    fd.append('mx_elapsed_ms', String(Date.now() - startedAt)); // server-side timing signal for Make
    if (tsToken) { fd.append('turnstile_token', tsToken); tsToken = ''; } // single-use; re-executed on retry

    // Typed answers reach the same spreadsheet, so they get the same formula guard.
    // Strings only -- a rating must stay a number in payload_json.
    function safe(v) { return typeof v === 'string' ? deFormula(v) : v; }

    var plain = {};
    cfg.fields.forEach(function (f) {
      if (f.type === 'group') (f.inputs || []).forEach(function (s) { if (answers[s.key] !== undefined) plain[s.key] = safe(answers[s.key]); });
      else if (f.type === 'file') { if (answers[f.key]) fd.append(f.key, answers[f.key], answers[f.key].name); }
      else if (answers[f.key] !== undefined) plain[f.key] = Array.isArray(answers[f.key]) ? safe(answers[f.key].join('; ')) : safe(answers[f.key]);
    });
    fd.append('payload_json', JSON.stringify(plain));
    Object.keys(plain).forEach(function (k) { fd.append(k, plain[k]); }); // flat copy for easy Make mapping

    fetch(ENDPOINT, { method: 'POST', body: fd })
      .then(function (r) { if (!r.ok && r.status !== 0) throw new Error(r.status); thanks(); })
      .catch(function () {
        root.innerHTML = '';
        var card = h('div', 'mxf-card');
        card.appendChild(h('p', 'mxf-error', "Something went wrong and your answers weren't sent. Please try again."));
        var retry = h('button', 'mxf-btn mxf-btn-next', 'Try again');
        retry.type = 'button'; retry.onclick = submit;
        card.appendChild(retry);
        root.appendChild(h('div', 'mxf-wrap')).appendChild(card);
      });
  }

  function thanks() {
    root.innerHTML = '';
    var card = h('div', 'mxf-card mxf-thanks');
    card.appendChild(h('h2', 'mxf-label', esc(cfg.thankYouTitle || 'Thank you!')));
    card.appendChild(h('p', 'mxf-help', esc(cfg.thankYou || 'Your answers have been received.')));
    root.appendChild(h('div', 'mxf-wrap')).appendChild(card);
    if (cfg.redirect) setTimeout(function () { location.href = cfg.redirect; }, 2500);
  }

  render();
})();
